import { useCreateUnlimitedGoalsAllowed } from 'features/goals';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'shared/assets/icons';
import { AddGoalContextMenu } from 'shared/components/connected/add-goal-context-menu';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';
import { useContextMenuState } from 'shared/hooks/use-context-menu-state';
import { useTheme } from 'styled-components';

export const HeaderButton: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const contextMenuRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const openPremiumDialog = useOpenPremiumDialog();
  const { allowed: createGoalAllowed } = useCreateUnlimitedGoalsAllowed();

  const { position, open, close } = useContextMenuState();

  const onAdd = (e: React.MouseEvent) =>
    createGoalAllowed ? open(e) : openPremiumDialog();

  return theme.isMobile ? null : (
    <>
      <Button
        ref={buttonRef}
        onClick={onAdd}
        size={Sizes.Small}
        variant={Variants.Contained}
        color={Colors.Primary}
        startIcon={Plus}
        preventDrag
      >
        {t('pages.goals.header.add-goal')}
      </Button>
      {!!position && (
        <AddGoalContextMenu
          ref={contextMenuRef}
          referenceElement={buttonRef}
          onClose={close}
        />
      )}
    </>
  );
};
